import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import SubjectRegistrationForm from "../ones/SubjectRegistrationForm";
import ExamCycleCreationForm from "../ones/ExamCycleCreationForm";

export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	
	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	async function getData() {
		await callApi("get-exam-cycle-data", { uuid }).then(response => {
			if (response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready && data) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							{data.title}
							<br />
              <span className="badge bg-primary">Exam Cycle</span>
						</h6>
						<hr/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Title</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.title}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Status</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.status}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Start Date</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{formatDate(data.dateStart).substring(0, 10)}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">End Date</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{formatDate(data.dateEnd).substring(0, 10)}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Classroom</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.classroomData?.name || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Stream</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{data.streamData?.name || "N/A"}
						</h6>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">Actions</h6>
								<div className="row">

									<div className="col-6 col-md-4 mt-2 mb-2">
										<button
											className="btn btn-outline-dark btn-sm btn-block"
											onClick={() => {
												appContext.navTo({
													item: 'side-view',
													subItem: 'exam-cycle-results-viewer',
													extraItem: data.uuid,
												})
											}}
										>
											View Results
										</button>
									</div>

									<div className="col-6 col-md-4 mt-2 mb-2">
										<button
											className="btn btn-outline-dark btn-sm btn-block"
											onClick={() => {
												appContext.navTo({
													item: 'side-view',
													subItem: 'exam-cycle-results-editor',
													extraItem: data.uuid,
												})
											}}
										>
											Edit Results
										</button>
									</div>

									<div className="col-6 col-md-4 mt-2 mb-2">
										<button
											className="btn btn-outline-dark btn-sm btn-block"
											onClick={() => {
												appContext.navTo({
													item: 'side-view',
													subItem: 'exam-cycle-results-processor',
													extraItem: data.uuid,
												})
											}}
										>
											Process Results
										</button>
									</div>


								</div>
							</div>
						</div>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">Edit Exam This Cycle</h6>
								<ExamCycleCreationForm
									streamUuid={data.streamUuid}
									classroomUuid={data.classroomUuid}
									callback={getData}
									data={data}
								/>
								
							</div>
						</div>
					</div>
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}